import { ACTIVITIES, ACTIVITIES_RESET } from '../redux/ActionTypes'

function initialState() {
  return {
    activeAttemptIndex: 0,
    attempts: [],
    attemptsUsed: [],
    grade: '',
    pageType: '',
    questionId: null,
    teacherGrade: null,
    teachersComments: '',
    timeStamp: '',
    typeActivity: '',
    userBook: {
      id: null,
    },
  }
}

export default function activities(state = initialState(), action) {
  switch (action.type) {
    case ACTIVITIES:
      return state ? { ...state, ...action.payload } : { ...action.payload }
    case ACTIVITIES_RESET:
      return initialState()
    default:
      return state
  }
}
